import { motion } from 'framer-motion';
import { FaChild, FaPrayingHands, FaTools, FaUsers, FaHandsHelping, FaMusic } from 'react-icons/fa';

const ministries = [
  {
    name: "Children's Ministries",
    icon: <FaChild />,
    description: "Nurturing young hearts in faith through joyful worship, Bible stories, and creative activities.",
    // image: '/images/children.jpg'
  },
  {
    name: "David's Angels Choir",
    icon: <FaMusic />,
    description: "Leading the congregation in heartfelt worship and praise through music and harmony.",
  },
  {
    name: "Prayer Group",
    icon: <FaPrayingHands />,
    description: "Interceding for the church, the city, and the nations with fervent prayer and spiritual authority.",
  },
  {
    name: "Technical Team",
    icon: <FaTools />,
    description: "Behind-the-scenes heroes ensuring sound, visuals, and digital outreach run smoothly.",
  },
  {
    name: "Welfare Committee",
    icon: <FaUsers />,
    description: "Caring for the needs of our members with compassion, support, and practical help.",
  },
  {
    name: "Outreach Ministry",
    icon: <FaHandsHelping />,
    description: "Taking the gospel beyond the walls through evangelism, service, and community engagement.",
  },
];

const MinistriesPage = () => {
  return (
    <section className="ministries-section">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        Our Ministries
      </motion.h2>
      <div className="ministries-grid">
        {ministries.map((ministry, index) => (
          <motion.div
                key={index}
                className="ministry-card"
                style={{
                    backgroundImage: `url(${ministry.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                }}
                initial={{ opacity: 0, scale: 0.8, rotate: index % 2 === 0 ? -2 : 2 }}
                whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                >
                <div className="ministry-overlay">
                    <div className="ministry-icon">{ministry.icon}</div>
                    <h3>{ministry.name}</h3>
                    <p>{ministry.description}</p>
                </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default MinistriesPage;
